import { Navigate, Outlet } from 'react-router';
import { useCurrentUser } from '@/hooks/use-current-user';
import { PageLoader } from './page-loader';

export function FiduciaireGate() {
  const { isLoading, isFiduciaire } = useCurrentUser();
  if (isLoading) return <PageLoader />;
  if (!isFiduciaire) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
